<div class="container" style="display: flex; flex-direction:column; justify-content: space-between; height:100%">
  <div class="row" style="align-items: center;">
    <div class="col-10">
      <h3 i18n class="display-6"
        align="center"
        style="padding-top: 10px; color: #005d87; font-weight: bold;">
    Add Logbook
  </h3>
    </div>

    <div class="col-2">
      @if (data.logbook.isValid()) {
        <button mat-mini-fab matTooltip="Delete logbook" style="background-color: coral; color: white" (click)="deleteLogbook()">
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>

  </div>


  <form [formGroup]="logbookForm">

    <!-- Logbook Questions -->

    <div class="row">

      <h6 i18n class="small-header">
          Logbook Number
        </h6>
      <mat-form-field appearance="fill">
        <mat-label i18n>
            Logbook Number
          </mat-label>
        <input matInput
          required
          maxlength="16"
          formControlName="logbookNumber"
          (input)="sharedMethodsService.forbidWhitespaceOnly('logbookNumber', logbookForm)">
          @if (logbookForm.get('logbookNumber')?.errors?.required) {
            <mat-error i18n>
            Required
          </mat-error>
          }
        </mat-form-field>

      </div>

      <div class="row">

        <h6 i18n class="small-header">
          Gear Type
        </h6>
        <mat-form-field appearance="fill">
          <mat-label i18n>
            Select
          </mat-label>
          <mat-select formControlName="gearType">
            @for (gear of ['Gill Net', 'Seine', 'Troll']; track gear) {
              <mat-option i18n
                [value]="gear">
              {gear, select, Gill Net {Gillnet} Seine {Seine} Troll {Troll}}
            </mat-option>
            }
          </mat-select>
          @if (logbookForm.get('gearType')?.errors?.required) {
            <mat-error i18n>
            Required
          </mat-error>
          }
        </mat-form-field>

      </div>


      <div class="row">

        <h6 i18n class="small-header">
             Vessel Name 
        </h6>
        <mat-form-field>
          <mat-label i18n>
                Vessel Name
            </mat-label>
          <input matInput
            required
            maxlength="50"
            formControlName="vesselName"
            (input)="sharedMethodsService.forbidWhitespaceOnly('vesselName', logbookForm)">
            @if (logbookForm.get('vesselName')?.errors?.required) {
              <mat-error i18n>
              Required
            </mat-error>
            }
          </mat-form-field>

          <h6 i18n class="small-header">
            Vessel Registration Number
       </h6>
          <mat-form-field>
            <mat-label i18n>
               VRN
           </mat-label>
            <input matInput
              required
              maxlength="16"
              formControlName="vesselNumber"
              (input)="sharedMethodsService.forbidWhitespaceOnly('vesselNumber', logbookForm)">
              @if (logbookForm.get('vesselNumber')?.errors?.required) {
                <mat-error i18n>
            Required
          </mat-error>
              }
            </mat-form-field>

          </div>

          @if (duplicateLogbookFlag) {
            <h6 i18n class="red-header"
              >
      Please enter a different logbook number. 
    </h6>
          }

        </form>

        <!-- Back and Add buttons -->
        <div class="row bottom-buttons">

          <div class="outer">

            <div class="inner" style="margin-right: 50%">
              <button i18n mat-stroked-button
                type="button"
                style="background-color: #005d87; color: white; font-weight: bold;"
                (click)="dialogRef.close('Back')">
              Back
          </button>    
            </div>

            <div class="inner">
              <button i18n mat-stroked-button
                align="end"
                type="submit"
                style="background-color: #ff6f61; color: white; font-weight: bold;"
                (click)="addLogbook()">
              Add
          </button>                
            </div>

          </div>

        </div>

      </div>
